<template>
	<BasePublishCategoriesWidget :fetch="{code: 'reference', response_fields: ['url_without_domain']}" v-slot="{items: category}">
		<template v-if="category?.length">
			<BasePublishPostsWidget :fetch="{category_code: 'reference', limit: 12, response_fields: ['id', 'title', 'url_without_domain', 'element_size', 'element_foil', 'main_image_thumbs']}" v-slot="{items}">
				<div class="portfolio" v-if="items?.length">			
					<div class="marquee-content">
						<div class="marquee-item" v-for="item in items" :key="item.id">
							<PublishIndexEntryPortfolio :item="item" />
						</div>
						<ClientOnly>
							<template v-if="!mobileBreakpoint">
								<div class="marquee-item" v-for="item in items" :key="item.id">
									<PublishIndexEntryPortfolio :item="item" />
								</div>
							</template>
						</ClientOnly>
					</div>
					<div class="portfolio-footer">
						<NuxtLink class="btn" :to="category[0].url_without_domain"><BaseCmsLabel code="show_all_portfolio_posts" /></NuxtLink>
					</div>
				</div>
			</BasePublishPostsWidget>
		</template>
	</BasePublishCategoriesWidget>
</template>

<script setup>
	const {mobileBreakpoint} = inject('rwd');
</script>

<style scoped lang="less">
	.marquee-content{
		display: flex; gap: 40px; animation: scroll 50s linear infinite; width: fit-content;
		@media (max-width: @l){gap: 30px;}
		@media (max-width: @m){
			gap: 16px; animation: none; overflow: auto; width: auto;
			&::-webkit-scrollbar{display: none;}
		}
		&:hover{animation-play-state: paused;}
	}
	@keyframes scroll {
		0% {
			transform: translateX(0);
		}
		100% {
			transform: translateX(-50%);
		}
	}
	.portfolio{
		overflow: hidden; padding: 40px 0 50px;
		@media (max-width: @l){padding: 30px 0 40px;}
		@media (max-width: @m){padding: 16px 0 38px;}	
	}
	.marquee-item{
		width: auto;
		@media (max-width: @m){
			width: 240px; flex-grow: 0; flex-shrink: 0;
			&:first-child{margin-left: 16px;}
			&:last-child{margin-right: 16px;}
		}
	}
	.marquee-item:deep(.pp){
		width: 320px; font-size: 14px;
		@media (max-width: @m){width: 100%;}	
	}
	:deep(.pp-cnt){bottom: 20px; left: 20px; right: 20px;}
	.portfolio-footer{
		text-align: center; padding-top: 40px;
		@media (max-width: @m){padding: 24px 16px 0;}	
	}
</style>